import { Link } from "react-router-dom";
import { deNom, useBranding } from "../../branding";
import { ButtonLink, cx } from "../../components";
import { useLiensTransition, useSectionReveal } from "../../motion";
import { ROUTES } from "../../shell";
import styles from "./Vitrine.module.css";

/** Ouvrir un compte : à qui c'est réservé, et ce qui se passe ensuite. */
export function VitrineCta() {
  const lien = useLiensTransition();
  const section = useSectionReveal<HTMLElement>();
  const { esn_name } = useBranding();

  return (
    <section ref={section} id="inscription" className={cx(styles.sombre, styles.section, styles.sectionSombre, styles.ecran)} aria-labelledby="cta-titre">
      <div className={styles.panneau} data-anim="reveal">
        <div className={styles.panneauTextes}>
          <p className={styles.surtitre}>Inscription</p>
          <h2 id="cta-titre" className={styles.sectionTitre}>
            Ouvrir un compte entreprise
          </h2>
          <p className={styles.sectionChapo}>
            L'inscription est réservée aux entreprises clientes {deNom(esn_name)}. Vous déposez une demande,
            l'équipe vous rappelle, valide votre compte et vous invite comme administrateur : vous choisissez alors
            votre mot de passe.
          </p>
          <p className={styles.note}>Consultants et équipe {esn_name} : votre accès arrive par invitation.</p>
        </div>
        <div className={styles.panneauActions}>
          <ButtonLink to={ROUTES.inscription} variant="primary" size="lg" {...lien(ROUTES.inscription, "cube-avant")}>
            Demander un compte
          </ButtonLink>
          <Link to={ROUTES.connexion} className={styles.lienDiscret} {...lien(ROUTES.connexion, "cube-avant")}>
            Déjà un compte ? Se connecter
          </Link>
        </div>
      </div>
    </section>
  );
}
